import { ApiPath } from "enums";
import { Get } from "utils";

export const getCardRedemptions = async ({ fleetId, ...query }) => {
  const res = await Get(`${ApiPath.CardRedemption}/fleet/${fleetId}`, query);
  return res.data;
};
